import * as React from "react";
// import { pure } from 'recompose';
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onSubmit,
    isVisible,
    errorLength,
    onOpenModal,
    /*pwdHold,pwdNew, pwdConfirm ,*/ onChange,
    error,
    success,
    pwdNotModified,
  } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CHANGEPASSWORD,
  ]);

  //
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isVisible}>
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        <BoxGrid
          title={i18next.t("MOT DE PASSE")}
          onClose={onOpenModal}
          classNames="boderShadow changed-btn-pwd animated slideInDown"
          error={!authorization}
          onSubmit={onSubmit}
          BtnTextSpan={i18next.t("valider")}
        >
          <form
            onSubmit={onSubmit}
            style={{
              width: "100%",
              height: "auto",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Styled.CartContainer>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("ancien mot de passe")} : </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput
                      error={error || pwdNotModified}
                    >
                      <StyledComponent.Input
                        title={i18next.t("ancien mot de passe")}
                        type="password"
                        placeholder="......."
                        name="pwdHold"
                        // value={pwdHold}
                        disabled={!authorization}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                </div>
                <div className="titleAction">
                  <h2 />
                </div>
              </div>
              <div className="extractionInfo left">
                <div className="titleAction">
                  <h2>{i18next.t("nouveau mot de passe")}: </h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput
                      error={error || errorLength || pwdNotModified}
                    >
                      <StyledComponent.Input
                        title={i18next.t("nouveau mot de passe")}
                        type="password"
                        placeholder="......."
                        name="pwdNew"
                        // value={pwdNew}
                        disabled={!authorization}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                </div>
                <div className="titleAction">
                  <h2>{i18next.t("confirmation du nouveau mot de passe")} :</h2>
                  <StyledComponent.Container>
                    <StyledComponent.ContainerInput
                      error={error || errorLength || pwdNotModified}
                    >
                      <StyledComponent.Input
                        title={i18next.t(
                          "confirmation du nouveau mot de passe"
                        )}
                        type="password"
                        placeholder="......."
                        name="pwdConfirm"
                        // value={pwdConfirm}
                        disabled={!authorization}
                        autoComplete="off"
                        onChange={onChange}
                      />
                    </StyledComponent.ContainerInput>
                  </StyledComponent.Container>
                </div>
              </div>
            </Styled.CartContainer>
          </form>
        </BoxGrid>
      </StyledComponent.ModalContainerInsider>
      <SnackBar
        style={{ backgroundColor: "#00E1B3" }}
        isVisible={success && !errorLength && !error}
        someTextSuccees={i18next.t("le mot de passe a ete modifie")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={errorLength}
        someTextSuccees={i18next.t(
          "les champs doivent contenir au moins 4 caractères"
        )}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={pwdNotModified}
        someTextSuccees={i18next.t("synthaxe invalide")}
      />
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={error}
        someTextSuccees={i18next.t("impossible de changer le mot de passe")}
      />
    </StyledComponent.ModalContainer>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  onClose?: any;
  onSubmit?: any;
  pwdHold?: any;
  errorLength?: any;
  pwdNew?: any;
  pwdConfirm?: any;
  onChange?: any;
  error?: any;
  success?: any;
  pwdNotModified?: any;
  onOpenModal?: any;
  isVisible?: boolean;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/modal/changepassword/component.tsx